import React, { useState } from "react";
import { IconButton } from "@mui/material";
import TargetingLine from "./TargetingLine";
import { Target } from "orion-components/CBComponents/Icons";
import PropTypes from "prop-types";
import $ from "jquery";
import { useSelector, useDispatch } from "react-redux";
import { moveToTarget } from "../../AppState/Actions";
import { mapStateSelector as mapRef, disabledFeedsSelector } from "orion-components/AppState/Selectors";
import { mapFiltersById } from "orion-components/ContextPanel/Selectors";
import { makeGetEntity } from "orion-components/GlobalData/Selectors";

const propTypes = {
	selectFloor: PropTypes.func,
	iconContainerStyle: PropTypes.object,
	movement: PropTypes.string,
	config: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	multipleTargets: PropTypes.bool,
	setFocus: PropTypes.func,
	targetIds: PropTypes.array,
	defaultVisibility: PropTypes.bool,
	map: PropTypes.object,
	geometry: PropTypes.object,
	feedId: PropTypes.string
};

const defaultProps = {
	selectFloor: () => { },
	iconContainerStyle: {},
	multipleTargets: false,
	setFocus: () => { }
};

const TargetingIcon = (props) => {
	const {
		selectFloor,
		iconContainerStyle,
		movement,
		config,
		id,
		multipleTargets,
		setFocus,
		targetIds,
		defaultVisibility,
		customStyles
	} = props;

	const dispatch = useDispatch();
	const getEntity = makeGetEntity();
	const getMapAppState = mapRef();
	const entity = useSelector((state) =>
		getMapAppState(state) && getMapAppState(state).entities[props.feedId] ? getEntity(state, props) : null
	);
	const map = useSelector((state) =>
		props.map
			? props.map
			: state.replayMapState
				? state.replayMapState.replayBaseMap.mapRef
				: state.mapState
					? state.mapState.baseMap.mapRef
					: null
	);
	const filters = useSelector((state) => (getMapAppState(state) ? mapFiltersById(state) : null));
	const disabledFeeds = useSelector((state) => disabledFeedsSelector(state));
	const offsetY = $(".bottom-dock-slideout").length ? -($(".bottom-dock-slideout").outerHeight() / 4) : 0;
	const floorPlanView = useSelector((state) => state.appState.persisted?.floorPlanView);
	const sitePlanEntities = useSelector((state) => state.appState.persisted?.sitePlanEntities);

	let geometry = useSelector((state) => (!map ? null : props.geometry));
	//Get entity
	// const entity = useSelector((state) =>
	// 	mapAppState && mapAppState.entities[props.feedId] ? getEntity(state, props) : null
	// );
	//Check if entity's displayType is map (or not set)
	if (
		entity &&
		entity.entityData &&
		["map", "facility"].includes((entity.entityData.displayType || "map").toLowerCase())
	) {
		if (!geometry || typeof geometry !== "object") {
			geometry = entity.entityData.geometry;
		}
	} else if (typeof geometry !== "object") {
		geometry = false;
	}
	const mapVisible = useSelector((state) =>
		state.replayMapState
			? state.replayMapState.replayBaseMap.visible
			: state.mapState
				? state.mapState.baseMap.visible
				: false
	);
	const mapStylesLoaded = map?.getStyle();

	const [draw, setDraw] = useState(false);
	const [x, setX] = useState(null);
	const [y, setY] = useState(null);
	const [rerender, setRerender] = useState(null);

	const mouseEnter = (e) => {
		const svg = e.target.closest("svg");
		const pos = svg.getBoundingClientRect();
		setDraw(true);
		setX(pos.right - pos.width / 2 - 6);
		setY(pos.top - 36);
		const rerender = setInterval(() => setDraw(true), 10);
		setRerender(rerender);
		map.on("move", () => rerender);
		map.on("moveend", () => {
			// cSpell:ignore moveend
			clearInterval(rerender);
		});
	};

	const mouseLeave = () => {
		clearInterval(rerender);
		setDraw(false);
		setX(null);
		setY(null);
		setRerender(null);
	};

	const onTargetClick = (e, geometry, map, movement) => {
		if (multipleTargets) {
			setFocus();
		} else {
			dispatch(moveToTarget(e, geometry, map, movement, offsetY));
			if (selectFloor !== null) {
				dispatch(selectFloor(props));
			}
		}
	};

	const isDisabled = floorPlanView
		? !Boolean(sitePlanEntities?.includes(id))
		: !entity
			? false
			: entity.entityType === "shapes"
				? disabledFeeds.includes(
					entity.entityData.properties.type === "LineString" ? "Line" : entity.entityData.properties.type
				)
				: disabledFeeds.includes(entity.feedId);
	const shouldRender =
		!isDisabled &&
		map &&
		mapVisible &&
		mapStylesLoaded &&
		geometry &&
		(defaultVisibility ||
			!filters ||
			!filters.length ||
			(multipleTargets && targetIds.length > 0
				? targetIds.some((key) => filters.includes(key))
				: filters.includes(id)));

	const checkFilters = (data) => {
		if (filters && filters.length) {
			if (data.targetEntityId) {
				return filters.includes(data.targetEntityId);
			} else {
				return true;
			}
		} else {
			return true;
		}
	};

	return shouldRender ? (
		<React.Fragment>
			{multipleTargets
				? geometry &&
				geometry.map((data) => {
					return (
						draw &&
						checkFilters(data) &&
						$(window).width() > 1023 && (
							<TargetingLine
								draw={draw}
								x={x}
								y={y}
								map={map}
								geometry={data}
								config={config || {}}
							/>
						)
					);
				})
				: draw &&
				$(window).width() > 1023 && (
					<TargetingLine draw={draw} x={x} y={y} map={map} geometry={geometry} config={config || {}} />
				)}
			<IconButton
				style={{ ...{ opacity: 1 }, ...iconContainerStyle }}
				onClick={(e) => onTargetClick(e, geometry, map, movement)} data-testid="orion-components-shared-components-targeting-icon-targeting-icon-icon-button"
			>
				<Target handleMouseEnter={mouseEnter} handleMouseLeave={mouseLeave} customStyles={customStyles} />
			</IconButton>
		</React.Fragment>
	) : null;
};

TargetingIcon.propTypes = propTypes;
TargetingIcon.defaultProps = defaultProps;

export default TargetingIcon;
